import React, { useState } from 'react';
import { Navbar, Container, Nav, Button, NavDropdown, Modal, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Plus, Pencil, Trash, Table, Download } from 'react-bootstrap-icons';

import { useUser } from './UserContext';

import logo from '../img/logo.PNG';
import "../css/Navbar.css";


function NavbarComponent() {

  const navigate = useNavigate();
  const { username, role, logout } = useUser();
  const [showModal, setShowModal] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleDownloadDB = async () => {
    setShowModal(false);
    setDownloading(true);

    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(`${API_URL}/download-db`);
      if (!response.ok) throw new Error("Errore durante il download del database");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Nome file dinamico
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const formattedDate = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      const filename = `targa_db_${formattedDate}.db`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Errore:", error);
      alert("Errore durante il download del database");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Navbar bg="light" variant="light" expand="md" sticky="top" className="shadow-sm">
        <Container>
          <Navbar.Brand onClick={() => navigate("/")} className="d-flex align-items-center" style={{ cursor: "pointer" }}>
            <img src={logo} alt="Logo" width="30" height="30" className="me-2" />
            <span className="fw-bold text-dark">TARGHE MATRICOLARI</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            
            <Nav className="me-auto">
              <Nav.Link onClick={() => navigate("/")} className="text-dark nav-hover">Home</Nav.Link>

              {/* Mostra menu solo se loggato */}
              {username && (
                <>
                  <NavDropdown title="Gestione Riga" id="nav-dropdown-riga" drop="end" className="text-dark">
                    <NavDropdown.Item onClick={() => navigate("/insert")} className="dropdown-hover">
                      <Plus className="me-2" /> Inserisci Riga
                    </NavDropdown.Item>

                    <NavDropdown.Item onClick={() => navigate("/update")} className="dropdown-hover">
                      <Pencil className="me-2" /> Aggiorna Riga
                    </NavDropdown.Item>

                    {role === 'admin' && (
                      <NavDropdown.Item onClick={() => navigate("/delete")} className="dropdown-hover">
                        <Trash className="me-2" /> Elimina Riga
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>

                  <NavDropdown title="Gestione Tabella" id="nav-dropdown-tabella" drop="end" className="text-dark">
                    <NavDropdown.Item onClick={() => navigate("/createTable")} className="dropdown-hover">
                      <Table className="me-2" /> Crea Tabella
                    </NavDropdown.Item>

                    <NavDropdown.Item onClick={() => navigate("/renameTable")} className="dropdown-hover">
                      <Pencil className="me-2" /> Rinomina Tabella
                    </NavDropdown.Item>

                    {role === 'admin' && (
                      <NavDropdown.Item onClick={() => navigate("/deleteTable")} className="dropdown-hover">
                        <Trash className="me-2" /> Elimina Tabella
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>
                </>
              )}
            </Nav>

            {/* Sezione destra */}
            <div className="d-flex align-items-center gap-2 ms-auto">
              {/* Solo admin può scaricare DB */}
              {role === 'admin' && (
                <Button variant="primary" onClick={() => setShowModal(true)}>
                  {downloading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-1" />
                      Download in corso...
                    </>
                  ) : (
                    <>
                      <Download className="me-1" /> Scarica DB
                    </>
                  )}
                </Button>
              )}

              {/* Utente loggato */}
              {username ? (
                <>
                  <Navbar.Text className="text-dark">
                    Signed in as: <strong>{username}</strong> ({role})
                  </Navbar.Text>
                  <Button variant="outline-dark" onClick={logout}>Logout</Button>
                </>
              ) : (
                // Nessun login → mostra solo pulsante di accesso
                <Button variant="primary" onClick={() => navigate("/login")}>
                  Login
                </Button>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Modal conferma download */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Conferma Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler scaricare una copia del database sul tuo computer?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Annulla</Button>
          <Button variant="primary" onClick={handleDownloadDB}>Conferma</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NavbarComponent;
